import { createAsyncThunk } from '@reduxjs/toolkit'
import { ColumnFiltersState } from '@tanstack/react-table'
import { InventoryAxios } from 'api/InventoryAxios'
import { WarehouseAxios } from 'api/WarehouseAxios'
import axios from 'axios'
import { count } from 'console'
// import { LoDashStatic } from 'lodash'
const API_URL = process.env.REACT_APP_BASE_URL
const headers = {
  'Content-Type': 'application/json'
}

export interface InventoryStockTransferLog {
  id?: number
  packageName: string
  districtCode: string
  districtName: string
  state: string
  status: boolean
  createBy?: string
  updatedBy?: string
  createDate?: string
  updateDate?: string
}
export interface PaginatedResponse<T> {
  count: number
  total_pages: number
  next: string | null
  previous: string | null
  results: T[]
}



export const InventoryStockTransferLog = createAsyncThunk(
  'inventorystocklog/InventoryStockTransferLog',
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters
  }: {
    page: number
    pageSize: number
    search?: string
    sort?: string
    order?: 'asc' | 'desc' | ''
    filters?: ColumnFiltersState
  }) => {
    try {
      const params: Record<string, any> = {
        page,
        page_size: pageSize
      }

      if (search) params.search = search?.trim() || "";

      if (sort) {
        params.ordering = order === 'desc' ? `-${sort}` : sort
      }

      if (filters && Array.isArray(filters)) {
        filters.forEach(filter => {
          const { id, value } = filter
          if (!id || value === undefined || value === '') return
          if ((id === 'updated_at' || id === 'created_at') && typeof value === 'object') {
            const { from_date, to_date } = value as { from_date?: string; to_date?: string }
            if (from_date) params[`${id}_from`] = from_date
            if (to_date) params[`${id}_to`] = to_date
          } else {
            params[id] = value
          }
        })
      }
      if (filters && Array.isArray(filters)) {
        filters.forEach(filter => {
          const { id, value } = filter
          if (!id || value === undefined || value === '') return
          if (
            (id === 'updated_at' || id === 'created_at') &&
            typeof value === 'object'
          ) {
            const { from_date, to_date } = value as {
              from_date?: string
              to_date?: string
            }
            if (id === 'updated_at') {
              if (from_date) params['updated_at_from'] = from_date
              if (to_date) params['updated_at_to'] = to_date
            }
            if (id === 'created_at') {
              if (from_date) params['created_at_from'] = from_date
              if (to_date) params['created_at_to'] = to_date
            }

          } else {
            params[id] = value
          }
        })
      }

      // const response: any = await InventoryAxios.get(`/api/stock-transfer-request/list/`, { params })
      const response: any = await WarehouseAxios.get(`/stock/list/?transferred_from/`, { params })

      console.log("resppppp:::::", response)
      const responseData = response.data?.data || []

      const approvedData = responseData.filter((item: any) => item.status === "Approved");

      return {
        data: approvedData,
        rowCount: approvedData.length,
      }

      // return {
      //   data: response?.data?.data || [],
      //   rowCount:  response?.data?.count || 0
      // }

    } catch (error: any) {
      console.error(
        'fetchOrganisation error:',
        error.response?.data || error.message
      )
      throw new Error('Network Error')
    }
  }
)

// export const InventoryStockTransferLogById = createAsyncThunk(
//   'inventorystocklog/fetchById',
//   async (id: string, { rejectWithValue }) => {
//     try {
//       const response = await Axios.get(`${API_URL}/organisation/${id}/`)
//       console.log('resp to update Id : ', response)
//       return response
//     } catch (err: any) {
//       return rejectWithValue(
//         err.response?.data || 'Failed to fetch organisations by ID'
//       )
//     }
//   }
// )

// export const updateInventoryStockTransferLog = createAsyncThunk(
//   'inventorystocklog/pdateInventoryStockTransferLog',
//   async (orgData: any) => {
//     const response: any = await Axios.put(
//       `${API_URL}/organization/${orgData?.organization_id}/update/`,
//       orgData
//     )
//     return response?.data?.data
//   }
// )
// export const updateStatusInOrg = createAsyncThunk(
//   'organisation/updateOrganisation2',
//   async (packageData: any) => {
//     console.log('pkgData:', packageData)
//     const response: any = await Axios.put(
//       `${API_URL}/organization/${packageData.id}/update/`, // <-- add 'api/' here, no extra slash after API_URL
//       packageData
//     )
//     console.log('updateOrganisation response:', response)
//     return response
//   }
// )

// export const addOrganisation = createAsyncThunk(
//   'organisation/addOrganisation',
//   async (packageData: any) => {
//     // const token = localStorage.getItem("authToken");
//     // if (!token) {
//     //   throw new Error("No authentication token found");
//     // }

//     const response = await Axios.post(`${API_URL}/organisation/`, packageData)
//     console.log('addOrganisation response:', response)
//     console.log('addOrganisation response:', response.data)
//     return response.data
//   }
// )

// export const deleteOrganisation = createAsyncThunk(
//   'packages/delete',
//   async (id: number, { rejectWithValue }) => {
//     try {
//       await axios.delete(`${API_URL}/${id}`, { headers })
//       return id
//     } catch (err: any) {
//       console.error('Delete error:', err)
//       return rejectWithValue(err.response?.data?.message || err.message)
//     }
//   }
// )

// export const fetchAllDropdowns = createAsyncThunk(
//   'organization/fetchAllDropdowns',
//   async () => {
//     try {

//       const [orgRes, industryRes, cityRes, stateRes, pincodeRes, coutryRes ] = await Promise.all([
//         Axios.get(`${API_URL}/organization/all-org/`, { headers }),
//         Axios.get(`${API_URL}/organization/dropdown/industry_type/`, {
//           headers
//         }),
//         Axios.get(`${API_URL}/organization/dropdown/org_city/`, {
//           headers
//         }),
//         Axios.get(`${API_URL}/organization/dropdown/org_state/`, {
//           headers
//         }),
//         Axios.get(`${API_URL}/organization/dropdown/org_pincode/`, { headers }),
//         Axios.get(`${API_URL}/organization/dropdown/org_country/`, { headers }),
//       ])

//       // console.log(orgRes,"orgRes");
//       // console.log(industryRes,"industryRes")
//       // console.log(cityRes,"cityRes")
//       // console.log(stateRes,"stateRes")
//       console.log(coutryRes,"coutryRes--------------------1")

//       return {
//         orgDropDown: Array.isArray(orgRes.data.data)
//           ? orgRes.data.data.map((item: any) => item.organization_name)
//           : [],
//         industryTypeDropDown: Array.isArray(industryRes.data.industry_type)
//           ? Array.from(new Set(industryRes?.data?.industry_type))
//           : [],
//         orgCityDropDown: Array.isArray(cityRes.data.org_city)
//           ? Array.from(new Set(cityRes?.data?.org_city))
//           : [],
//         orgStateDropDown: Array.isArray(stateRes.data.org_state)
//           ? Array.from(new Set(stateRes?.data?.org_state))
//           : [],
//         pincodeDropDown: Array.isArray(pincodeRes?.data?.org_pincode) ? Array.from(new Set(pincodeRes?.data?.org_pincode)) : [],
//         countryDropDown: Array.isArray(coutryRes?.data?.org_country) ? Array.from(new Set(coutryRes?.data?.org_country)) : [],
//       }
//     } catch (err) {
//       console.log(err)
//       throw err
//     }
//   }
// )
// //Exports csv file
// // Exports department CSV file
// export const exportOrganisationsCSV = createAsyncThunk(
//   'department/exportCSV',
//   async (_, { rejectWithValue }) => {
//     try {
//       const token = localStorage.getItem("authToken");
//       const headers = {
//         Authorization: `Bearer ${token}`,
//         'Content-Type': 'application/json',
//         'Accept': '*/*'
//       };
//       const response = await Axios.get(
//         '/organization/?export=excel',
//         { headers, responseType: 'blob' }
//       );
//       return {
//         blob: response.data,
//         filename:
//           response.headers['content-disposition']
//             ?.split('filename=')[1]
//             ?.replace(/"/g, '') || 'organisations.csv'
//       };
//     } catch (err: any) {
//       console.error('Export CSV error:', err);
//       return rejectWithValue(err.message || 'Failed to export CSV');
//     }
//   }
// );

// export const OrganisationsExportsCSV = async ({
//   search,
//   filters,
// }: {
//   search?: string;
//   filters?: any;
// }) => {
//   const params = new URLSearchParams();
//   params.append("export", "excel");

//   if (search) params.append("search", search);

//   if (filters && filters.length > 0) {
//     filters.forEach(({ id, value }: { id: string; value: any }) => {
//       if (id && value !== undefined && value !== null) {
//         if (typeof value === "object" && value !== null) {
//           const maybeDateFilter = value as {
//             from_date?: string;
//             to_date?: string;
//           };

//           if (
//             (maybeDateFilter.from_date || maybeDateFilter.to_date) &&
//             (id === "created_at" || id === "updated_at")
//           ) {
//             if (maybeDateFilter.from_date) {
//               params.append(`${id}_from`, maybeDateFilter.from_date);
//             }
//             if (maybeDateFilter.to_date) {
//               params.append(`${id}_to`, maybeDateFilter.to_date);
//             }
//             return;
//           }

//           // Other object filters
//           Object.entries(value).forEach(([key, val]) => {
//             if (val !== undefined && val !== null && val !== "") {
//               params.append(key, String(val));
//             }
//           });
//         } else {
//           params.append(id, value);
//         }
//       }
//     });
//   }

//   const response = await Axios.get(`/organization/?${params.toString()}`, {
//     responseType: "blob",
//   });

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "Organisation.csv",
//   };
// };

